export const featurePromoConstants = {
  UPDATE_FEATURE_PROMO: 'update_feature_promo',
  UPDATE_FEATURE_PROMO_EVENT: 'update_feature_promo_event',
  UPDATE_FEATURE_PROMO_FINISHED: 'update_feature_promo_finished',
};

export const FEATURE_PROMO_LOCAL_STORAGE_KEY = 'featurePromos';
